(function () {
  function buildSuggestions() {
    try {
      const log = JSON.parse(localStorage.getItem('cc404_log') || '[]');
      if (!log.length) return;
      const counts = {};
      log.forEach(function (entry) {
        counts[entry.path] = (counts[entry.path] || 0) + 1;
      });
      const sorted = Object.keys(counts)
        .sort(function (a, b) {
          return counts[b] - counts[a];
        })
        .slice(0, 10);
      if (!sorted.length) return;
      const nav = document.createElement('nav');
      nav.className = 'cc404-suggestion-map';
      nav.hidden = true;
      const list = document.createElement('ul');
      sorted.forEach(function (path) {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = path;
        link.rel = 'nofollow';
        link.textContent = path;
        li.appendChild(link);
        list.appendChild(li);
      });
      nav.appendChild(list);
      document.body.appendChild(nav);
    } catch (_e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildSuggestions);
  } else {
    buildSuggestions();
  }
})();
